import type { ValidationError } from '../types/api'

export const formatValidationError = ({ violations }: ValidationError['error']) => {
  const errorFieldValues = Object.values(violations)
  const errorMessages = errorFieldValues.map((err) => err.join('\n'))

  return errorMessages.join('\n')
}
